<template>
  <div class="container">
    <dingbu></dingbu>
    <div class="home_content">
      <div
        class="bg_color"
        :style="{
          background:
            'url(' +
            require('../../assets/img/' + bei_ing) +
            ') no-repeat center center',
          'background-size': '100% 100%',
        }"
      >
        <div class="w">
          <div class="inform__box">
            <div class="box__top">
              <span class="shou__ye">首页</span>
              <span>
                <img class="img__o" src="../../assets/xiangyou (2).png" alt />
              </span>
              <router-link tag="span" class="ton__zhi2" to="/learn"
                >学习中心</router-link
              >
              <span>
                <img class="img__o" src="../../assets/xiangyou (2).png" alt />
              </span>
              <div class="ton__zhi2" @click="kechengs">课程列表</div>
              <span class></span>
              <span>
                <img class="img__o" src="../../assets/xiangyou (2).png" alt />
              </span>
              <span class="ton__zhi">课程详情</span>
            </div>
          </div>
          <div class="box-mat">
            <div class="box-lok">
              <div
                class="box-list"
                v-for="(item, index) in addkio"
                :key="index"
                :data-index="index"
                :class="orderindex == index ? 'orderactivegd' : ''"
                @click="selorder"
              >
                <img class="ziliao" :src="item.url" alt />
                <div class="ziliao-text">{{ item.text }}</div>
              </div>
            </div>
            <div class="box-contentukj">
              <div class="ke-title">{{ addki.name }}</div>
              <div class="kecheng-listto">
                <div class="listto-ke">
                  <div class="class_hour">{{ addki.class_hour }}课时</div>
                  <div class="minrd">课程时长：{{ addki.min }}分钟</div>
                  <div class="jiezhi-time">
                    截止时间：{{ addki.expirationtime }}
                  </div>
                </div>
                <div
                  class="xuexi-jihua"
                  plain="true"
                  @click="jixue"
                  v-if="is_join == 1"
                >
                  + 加入学习计划
                </div>
                <div
                  class="xuexi-jihuaa"
                  plain="trueo"
                  @click="jixue"
                  v-if="is_join == 2"
                >
                  已加入
                </div>
              </div>
              <div class="shiping">
                <video-player
                  height="100%"
                  width="100%"
                  class="video-player vjs-custom-skin"
                  ref="videoPlayer"
                  :playsinline="true"
                  :options="playerOptions"
                  @pause="onplayerPause($event)"
                  @ready="playerReadied"
                  @timeupdate="onPlayerTimeupdate($event)"
                  @statechanged="playerStateChanged($event)"
                  @play="onPlayerPlay($event)"
                ></video-player>
              </div>
              <div class="kecheng">课程详情</div>
              <div class="kecheng-text" v-html="addki.content"></div>
            </div>
          </div>
        </div>

        <el-dialog
      title="请进行人脸识别"
      :visible.sync="dialogVisible"
      width="600px"
      :before-close="handleClose"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div style="text-align: center;">
        <div id="qrcode" ref="qrcode"></div>
		<div class="login__name">请使用微信扫码</div>
      </div>
    </el-dialog>
        <dibu></dibu>
        <daohan></daohan>
      </div>
    </div>
  </div>
</template>

<script>
import daohan from "../daohan";
import dibu from "../dibu";
import dingbu from "../dingbu";
import QRCode from "qrcodejs2";

export default {
  components: {
    daohan,
    dibu,
    dingbu,
  },
  data() {
    return {
      id: "",
      muted: false,
      orderindex: 1,
      zhebi: true, // 作废了
      addki: [],
      jia: false,
      fan: false,
      addkio: [
        {
          url: require("@/assets/img/img_21.png"),
          text: "我的资料",
        },
        {
          url: require("@/assets/img/img_20.png"),
          text: "课程列表",
        },
        {
          url: require("@/assets/img/img_35.png"),
          text: "我的课程",
        },
        {
          url: require("@/assets/img/img_19.png"),
          text: "考试记录",
        },
        {
          url: require("@/assets/img/img_18.png"),
          text: "修改密码",
        },
      ],
      vio: true, // 播放按钮
      duration: "",
      controls: false,
      coutent: "",
      gosid: "",
      orderid: "",
      miao: "",
      is_endt: "",
      is_join: "1",
      bei_ing: this.Public.bei_ing,
      is_fast_switch: "",
      i: 1,
      // 视频标签

      playerOptions: {
        playbackRates: [1.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "",
            src: "", //url地址
          },
        ],
        poster: "", //你的封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },

      gklog: 0, //视频观看时长
      duration: "",
      zhan_time: 0,
      zhan_switch: 0, //是否中途暂停视频
      stopnum:0,//暂停的时间
      face_switch: 0,
      face_status: 1,
      dialogVisible: false,
      pageUrl: "",
      timer: null,     // 轮询定时器id
      isAuthOk: false,
      t: "",
      sdk:{},
      statusText: '正在获取二维码...'
    };
  },
  created() {
    window.addEventListener("beforeunload", (e) => this.beforeunloadFn(e));
    let that = this;
    that.id = this.$route.query.id;
    that.gosid = this.$route.query.gosid;
    console.log(this.id);
  },
  mounted() {
    window.addEventListener("beforeunload", (e) => this.beforeunloadHandler(e));
    console.log(this.$refs.videoPlayer, "正常");
    this.getzan();
    this.gosid = this.$route.query.gosid;
    this.orderid = this.$route.query.orderid;
    // 记录视频进度（关闭或刷新当前页面）
    window.onbeforeunload = () => {
      if (this.gklog) {
        this.duration = this.gklog;
        this.ad();
      }
      return "tips";
    };

    let url = "agryjxjy/sync";
    let param = {
      id: this.gosid,
    };
    this.post(url, param).then((res) => {
      console.log("agryjxjy/sync posted");
    });
    this.getvideo_detail();
  },
  unmounted() {
    if (window.SafetyAuditSDK) {
      this.sdk.destroy();
      console.log("agryjxjy SafetyAuditSDK unmounted");
    }
  },
  // 记录视频进度（去别的页面）
  destroyed() {
    window.removeEventListener("beforeunload", (e) => this.beforeunloadFn(e));
    let that = this;
    if (that.gklog) {
      that.duration = that.gklog;
      that.ad();
    }
    window.onbeforeunload = null;
    console.log("我被销毁了");
    this.change_view_status(0);
  },
  computed: {
    playData() {
      return this.$refs.videoPlayer.player;
    },
  },
  beforeRouteLeave(to, form, next) {
    next();
  },
  methods: {
    beforeunloadFn(e) {
      console.log("刷新或关闭");
      // ...
      this.change_view_status(0);
    },
    playerStateChanged(playerCurrentState) {
    },
    //如果接口关闭快进按钮，直接禁用进度条，防止点击进度条暂停视频
    onPlayerPlay(player) {
      console.log("开始");
      this.change_view_status(1);
      if (this.is_fast_switch == 0) {
        document.querySelector(".vjs-progress-control").style.pointerEvents =
          "none";
      }
    },
    onPlayerTimeupdate(player) {
      // 获取视频播放进度
      // console.log(player,'大')
      this.gklog = player.cache_.currentTime;
      console.log(player.cache_.duration, player.cache_.currentTime);
      if (this.zhan_switch == 1) {
        if (player.cache_.currentTime > this.zhan_time) {
          this.playData.pause();
          this.change_view_status(0);
          this.zhan_time += this.stopnum;
          if (this.face_switch == 1) {
            this.face_status = 2;
            this.dialogVisible = true;
            this.fetchUrlAndGenerateQrcode();
          }
        }
      }
    },
    onplayerPause(player) {
      // 点击暂停时触发
      console.log("暂停");
      this.change_view_status(0);
      this.duration = player.cache_.currentTime;
      this.Recordtheplay();
    },
    playerReadied(player) {
      // 设置视频进度
      console.log(this.gklog);
      player.currentTime(this.gklog);
      console.log(player);
    },
    async fetchUrlAndGenerateQrcode() {
      let that = this;
      try {
        // 1. 获取二维码url

        // 2. 生成二维码
        this.$nextTick(() => {
          this.createQrcode(this.pageUrl)
          this.statusText = '请微信扫码，等待认证...'
        })

        // 3. 开始每秒轮询认证结果
        this.startPolling()

      } catch (e) {
        console.error('初始化失败：', e)
        this.statusText = '获取二维码失败'
      }
    },

    startPolling() {
      let that = this,
					url = "lists2/face3?token="+that.t,
					param = {};
      if (this.timer) return // 防止重复开启
      this.timer = setInterval(async () => {
        if (this.isAuthOk) return
        try {
          const res = await this.post(url)
          // 假设接口返回 { code:200, success:true } 表示认证完成
          if (res.data && res.data.facestate==3) {
            this.isAuthOk = true
            this.stopPolling()
            this.$message.success('认证完成！') 
            this.statusText = '认证成功，可进行下一步'
            this.dialogVisible = false;
          }
        } catch (e) {
          console.warn('轮询接口异常：', e)
        }
      }, 3000) // 3秒一次
    },

    stopPolling() {
      console.log('停止轮询')
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    // 3. 生成二维码
    createQrcode(url) {
      // 先清空容器，防止重复生成
      this.$refs.qrcode.innerHTML = "";

      new QRCode(this.$refs.qrcode, {
        text: url, // 二维码内容（就是页面url）
        width: 200,
        height: 200,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H, // 容错级别
      });
    },
    handleClose() {
      this.stopPolling()
      this.dialogVisible = false;
    },
    Recordtheplay() {
      //播放按钮
      let that = this,
        url = "user/bofang",
        param = {
          id: that.gosid,
          duration: that.duration,
        };
      this.post(url, param)
        .then((res) => {
          console.log(res);
          console.log("我是我1");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    change_view_status(e) {
      let that = this;
      let url = "user/change_view_status";
      let param = {
        view_status: e,
        view_id: that.gosid,
      };
      that.post(url, param).then((res) => {});
    },
    getvideo_detail() {
      // 详情接口
      let that = this;
      var url = "user/video_detail";
      let param = {
        id: this.gosid,
      };
      that
        .post(url, param)
        .then((res) => {
          that.addki = res.data;
          this.playerOptions["sources"][0]["src"] = res.data.video_file;
          this.playerOptions["poster"] = res.data.video_image;
          this.gklog = res.data.bofangtime;
          this.is_fast_switch = res.data.is_fast_switch;
          console.log(this.playerOptions["sources"][0]["src"]);
          that.is_endt = res.data.is_end; // 开始状态 1
          that.is_join = res.data.is_join;
          if (that.addki.is_end == 1) {
            that.controls = true;
            that.coutent = 0;
          } else {
            that.coutent = that.addki.bofangtime;
          }
          console.log(that.coutent, "开始播放的时间 后者视频时长"); //
          console.log(res.data, "详情");
          console.log(this.is_fast_switch, "this.is_fast_switch ");
          that.zhan_switch = res.data.auto_pause.switch; //是否中途暂停
          if (that.zhan_switch == 1) {
            that.zhan_time = that.coutent+ (res.data.auto_pause.stopnum * 60);
            that.stopnum = res.data.auto_pause.stopnum *60
          }
          that.face_switch = res.data.auto_pause.face_switch;
          that.pageUrl=res.data.face;
          that.t=localStorage.getItem("token-qzb");
          
          console.log(that.zhan_time, "时间");
          that.post("agryjxjy/learning", param).then((res) => {
            console.log(res)
            if (res.data) {
              let dt = res.data;
              // 检查 SDK 是否加载成功
              if (window.SafetyAuditSDK) {
                that.sdk = new window.SafetyAuditSDK({
                  token: dt.session_token,
                  mode: 'learning',                // learning | exam
                  baseURL: 'https://www.agryjxjy.cn',
                  reportInterval: 5000,            // 上报间隔(ms)，默认 5000
                  debug: false,                    // 开启调试日志
                });

                // 绑定视频元素（如果有）
                const video = document.querySelector('video');
                if (video) {
                  that.sdk.bindVideo(video);
                }
              }
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    ji() {
      this.jia = false;
      this.fan = true;
    },
    xuea() {
      this.fan = false;
      sessionStorage.setItem("videoxian", 2);
      document.body.style.overflow = ""; // 出现滚动条
      document.removeEventListener("touchmove", { passive: false });
    },
    getPath() {
      console.log(this.$route.path);
    },
    //返回课程列表
    kechengs() {
      if (sessionStorage.getItem("kai")) {
      } else {
        sessionStorage.setItem("kai", 1);
      }
      this.$router.push("/profile?id=" + this.id + "&orderindex=1");
    },
    test(e) {
      alert("111");
    },
    //侧边导航按钮
    selorder(e) {
      this.orderindex = e.currentTarget.dataset.index;

      localStorage.setItem("ordertodo", this.orderindex);
      if (this.orderindex == 0) {
        this.$router.push({ path: "/profile", query: { id: this.id } });
      }
      if (this.orderindex == 2) {
        this.$router.push({ path: "/profile", query: { id: this.id } });
      }
      if (this.orderindex == 3) {
        this.$router.push({ path: "/profile", query: { id: this.id } });
      }
      if (this.orderindex == 4) {
        this.$router.push({ path: "/profile", query: { id: this.id } });
        document.getElementById("app").scrollIntoView();
        var mo = function (e) {
          e.preventDefault();
        };
        document.body.style.overflow = "hidden";
        document.addEventListener("touchmove", mo, false); //禁止页面滑动
      }
      if (this.orderindex == 5) {
        this.$router.push({ path: "/profile", query: { id: this.gosid } });
        document.documentElement.scrollTop = 200;
        document.getElementById("app").scrollIntoView();
        var mo = function (e) {
          e.preventDefault();
        };
        document.body.style.overflow = "hidden";
        document.addEventListener("touchmove", mo, false); //禁止页面滑动
      }
    },
    //视屏播放
    videofang(time) {
      console.log(time);
      this.controls = true;
      let n = 1,
        that = this,
        ting = that.miao,
        sym,
        sec;
      var video = document.getElementById("video");
      if (this.is_endt == 2) {
        // 开始播放时的状态  1 / 2
        // this.zhebi = true
        setInterval(function () {
          var timel = video.currentTime;
          if (timel - sym > 1) {
            video.currentTime = sym;
          }
          sym = video.currentTime;
        }, 500);
      } else {
        this.zhebi = false;
      }
      if (video.paused) {
        video.currentTime = time;
        if (this.controls == false) {
          video.play();
        }
        this.vio = false;
        video.addEventListener("timeupdate", function () {
          var timeDisplay;
          //用秒数来显示当前播放进度
          timeDisplay = Math.floor(video.currentTime);
          that.duration = Math.floor(video.currentTime);
          that.coutent = that.duration;
          console.log(Math.floor(video.currentTime));
          console.log(that.duration, " that.duration");
          sessionStorage.setItem("coutent-qzb", that.duration);
          if (that.duration >= that.addki.duration) {
            that.ad();
            that.controls = true;
          }
        });
      } else {
        if (this.controls == false) {
          video.pause();
          this.ad();
        }
        console.log(that.duration);
        if (that.duration > 0) {
          this.ad();
        }
      }
    },

    ad() {
      //播放按钮
      console.log("我执行了");
      let that = this,
        url = "user/bofang",
        param = {
          id: that.gosid,
          duration: that.duration,
        };
      this.post(url, param)
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    jixue() {
      //加入学习计划
      let that = this,
        url = "user/join",
        param = {
          id: that.gosid,
          duration: that.duration,
        };
      this.post(url, param)
        .then((res) => {
          that.is_join = 2;
          that.$message(res.msg);
          localStorage.setItem("id", id);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getzan() {
      //到达一定时间暂停接口
      let that = this;
      var url = "index/zan";
      let param = {};
      this.post(url)
        .then((res) => {
          this.miao = res.data.stopnum;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style>
</style>
<style scoped>
@import "../../css/train.css";

.qrcode-box {
  text-align: center;
  padding: 20px;
}
#qrcode {
  display: inline-block;
  margin-top: 10px;
}
</style>